import COLORS from './colors';

const fields = {
  styleOverrides: {
    root: {
      '& .MuiInputBase-root': {
        '&.MuiOutlinedInput-root': {
          borderRadius: 8,
          color: '#666666',

          '& .MuiOutlinedInput-notchedOutlin': {
            borderColor: 'rgba(102, 102, 102, 0.35)'
          },
        }
      },
      '&.readOnly': {
        '& .MuiInputBase-root': {
          '&.MuiOutlinedInput-root': {
            borderRadius: 8,

            '& .MuiOutlinedInput-notchedOutlin': {
              borderColor: 'rgba(102, 102, 102, 0.35)'
            },
          },

          '&:after, &:before': {
            display: 'none !important'
          }
        }
      },
      '& .MuiInputLabel-root': {
        fontSize: 16,
        color: '#666666',

        '&.Mui-focused': {
          color: COLORS.textSecondColor,
        },

        '&.Mui-error': {
          color: COLORS.red
        }
      },

      '& .MuiInputBase-input': {
        fontSize: 16,
        color: '#666666',

        '&.MuiInputBase-inputMultiline': {
          fontWeight: 400,

          '&::-webkit-scrollbar-track, &::-webkit-scrollbar-thumb, &::-webkit-scrollbar': {
            width: 3,
            height: 3,
            background: '#fff',
            borderRadius: 10,
            cursor: 'pointer'
          },

          '&::-webkit-scrollbar-thumb': {
            background: COLORS.accent
          }
        },

        '&:focus': {
          backgroundColor: 'transparent',
          color: COLORS.textSecondColor,
        },

        '&::-webkit-outer-spin-button, &::-webkit-inner-spin-button': {
          appearance: 'none',
          margin: 0
        }
      },

      '& .MuiInputAdornment-root': {
        '& .MuiButtonBase-root': {
          margin: 0
        }
      }
    }
  }
};

export default fields;
